import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { emailsList, emailsListNext, openModal } from "../../actions";
import Table from "../../components/Table";
import EmailListItem from "../../components/EmailListItem";
import NonIdealState from "../../components/NonIdealState";
import ListEmailToolbar from "./ListEmailToolbar";

const identity = (data) => data;

export class ListEmailPage extends Component {
  constructor(props) {
    super(props);
    this.renderEmail = this.renderEmail.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onClone = this.onClone.bind(this);

    this.state = {
      deleteOpen: true,
      emailName: "aadfs",
    };
  }

  componentWillMount() {
    this.props.emailsList(this.props.match.params.accountId, {}, true);
    this.fetchMore = this.fetchMore.bind(this);
  }

  onDelete(emailId) {
    this.props.openModal("delete-email", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onClone(emailId) {
    this.props.openModal("clone-email", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  fetchMore() {
    this.props.emailsListNext(this.props.match.params.accountId);
  }

  renderEmail(email) {
    return (
      <EmailListItem
        email={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  render() {
    const { emails, isFetching } = this.props;

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Emails`}</title>
        </Helmet>
        <ListEmailToolbar accountId={this.props.match.params.accountId} />
        {emails.length > 0 ? (
          <Table
            renderItem={this.renderEmail}
            items={emails}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : !isFetching ? (
          <NonIdealState title="No Emails Found" visual="warning" />
        ) : (
          <NonIdealState title="Loading" visual="refresh" spin />
        )}
      </div>
    );
  }
}

ListEmailPage.propTypes = {
  params: PropTypes.object.isRequired,
  emailsList: PropTypes.func.isRequired,
  emailsListNext: PropTypes.func.isRequired,
  emails: PropTypes.array.isRequired,
  openModal: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const emailsPagination = state.pagination.emails || {};
  const emails = (emailsPagination.ids || [])
    .map((id) => state.entities.email[id])
    .filter(identity);
  const isFetching = emailsPagination.isFetching;

  return {
    emails,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailsList,
  emailsListNext,
  openModal,
})(ListEmailPage);
